import { render, staticRenderFns } from "./ContatoFornecedor.vue?vue&type=template&id=80a2e8a2&scoped=true"
import script from "./ContatoFornecedor.vue?vue&type=script&lang=js"
export * from "./ContatoFornecedor.vue?vue&type=script&lang=js"
import style0 from "./ContatoFornecedor.vue?vue&type=style&index=0&id=80a2e8a2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a2e8a2",
  null
  
)

export default component.exports